var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDimond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4947 0.875H9.50542L0.625 14.1955V16.7129L19.2537 44.75H30.7463L49.375 16.7129V14.1955L40.4947 0.875ZM38.7554 4.125L45.1952 13.7847H34.3172L31.2774 4.125H38.7554ZM22.1296 4.125H27.8704L30.9101 13.7847H19.0899L22.1296 4.125ZM11.2447 4.125H18.7226L15.6828 13.7847H4.8048L11.2447 4.125ZM20.9963 41.5L4.74082 17.0347H15.587L21.3248 41.5H20.9963ZM24.6627 41.5L18.9252 17.0347H31.0748L25.337 41.5H24.6627ZM29.0034 41.5H28.6749L34.4132 17.0347H45.2592L29.0034 41.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimond);
export default __webpack_public_path__ + "static/media/dimond.c670d39b52b88f4a0ef8f7e21f884693.svg";
export { ForwardRef as ReactComponent };